@if (showLabel) {
  <label class="text-sm text-gray-700 font-medium">{{ property.name }}</label>
}
<form
  class="ml-2 flex flex-col gap-1"
  [formGroup]="form"
  *vsLet="assignments$ | async as assignments"
  [class]="open ? 'visible' : 'hidden'"
>
  <ng-container *ngFor="let assignment of $any(assignments | sortProperties: showHidden)">
    @if (showHidden || !assignment.hidden) {
      <vs-property-input-form-field
        [property]="assignment.property!"
        [required]="assignment.required"
        [hidden]="assignment.hidden"
        [showHidden]="showHidden"
        [displayLabel]="assignment.displayLabel"
        [helpText]="assignment.helpText"
        [formControlName]="assignment.property!.valueKey"
        (touched)="markAsTouched()"
        [required]="assignment.required"
      >
      </vs-property-input-form-field>
    }
  </ng-container>
</form>
